import Cookies from "js-cookie";
import history from "../history";

export function readSessionUser() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && typeof user === "object" && !Array.isArray(user) ? user : null;
  } catch (error) {
    return null;
  }
}

function currentToken() {
  const user = readSessionUser();
  const token = (user && user.access_token) || Cookies.get("Set-Cookie");
  return typeof token === "string" && token !== "null" && token !== "undefined" ? token : "";
}

export function clearSession() {
  try { localStorage.removeItem("user"); } catch (error) { /* Storage may be unavailable. */ }
  Cookies.remove("Set-Cookie");
}

export function configureSessionClient(api) {
  api.defaults.withCredentials = false;
  api.interceptors.request.use(config => {
    config.headers = config.headers || {};
    [config.headers, config.headers.common || {}].forEach(headers => {
      Object.keys(headers).forEach(key => { if (/^(authorization|cookie)$/i.test(key)) delete headers[key]; });
    });
    // The login page also checks an existing session through protected menu reads.
    config.skipSessionAuth = config.skipSessionAuth === true;
    const token = currentToken();
    if (token && !config.skipSessionAuth) config.headers.Authorization = "Bearer " + token;
    config.headers.Accept = "application/json";
    config.withCredentials = false;
    return config;
  });
  api.interceptors.response.use(response => response, error => {
    const request = error && error.config;
    if (error && error.response && error.response.status === 401 && request && !request.skipSessionAuth) {
      const token = currentToken();
      const sent = request.headers && request.headers.Authorization;
      // A late rejection from an old request must not erase a newer login.
      if (!token || sent === "Bearer " + token) {
        clearSession();
        if (window.location.pathname !== "/login") history.push("/login");
      }
    }
    return Promise.reject(error);
  });
  return api;
}
